import { render, staticRenderFns } from "./WonderYjjRateML.vue?vue&type=template&id=d530a90a"
import script from "./WonderYjjRateML.vue?vue&type=script&lang=js"
export * from "./WonderYjjRateML.vue?vue&type=script&lang=js"
import style0 from "./WonderYjjRateML.vue?vue&type=style&index=0&id=d530a90a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports